import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Stack, Typography } from "@mui/material";
import React from "react";
import { ONBOARDING_COLORS } from "./onboardingDesign.js";

/**
 * "Account created" / "Setup done": a green check mark with a small spaced-out
 * uppercase label. It confirms something that already happened, so it is text
 * with an icon rather than a chip, which would read as a clickable control.
 */
export const OnboardingStatusLabel = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <Stack
    direction="row"
    spacing="8px"
    sx={{ alignItems: "center", color: ONBOARDING_COLORS.success }}
  >
    <CheckCircleIcon aria-hidden sx={{ fontSize: 20 }} />
    <Typography
      component="span"
      sx={{
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1.45,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
      }}
    >
      {children}
    </Typography>
  </Stack>
);
